@if (product$ | async; as product) {
  @if (product.rfuvpPrice) {
    <div class="price">
      <span> {{ 'productDetails.rfuvpPrice' | cxTranslate }} </span>
      <span> {{ product.rfuvpPrice?.formattedValue }} </span>
    </div>
  }
  <div class="price">
    <span> {{ 'productDetails.uvpPrice' | cxTranslate }} </span>
    <span> {{ product.uvpPrice?.formattedValue }} </span>
  </div>
  @if (!hasShopViewUserRole) {
    <div class="price">
      <span> {{ 'productDetails.priceMargin' | cxTranslate }} </span>
      <span> {{ product.formattedCalculatedProfitMargin }}&#37; </span>
    </div>
  }
  @if (!hasShopViewUserRole) {
    <div class="price price-ek">
      <span>{{ 'productDetails.ekPrice' | cxTranslate }}</span>
      <span> {{ product.ekPrice?.formattedValue }} </span>
    </div>
  }
  @if (showBestPrice && !hasShopViewUserRole) {
    <div (mouseenter)="toggleDiscounts(true)" (mouseleave)="toggleDiscounts(false)" class="price price-best">
      <span>{{ 'productDetails.bestPrice' | cxTranslate }}</span>
      <span> {{ product.bestPrice?.formattedValue }} </span>
    </div>
  }
  @if (this.showDiscounts) {
    <div class="discounts">
      <div class="discount-heading">{{ 'productDetails.bestPrice' | cxTranslate }}</div>
      <div class="discount-body">
        <table>
          <thead>
            <tr>
              <th><strong>{{ 'productDetails.discountName' | cxTranslate }}</strong></th>
              <th><strong>%</strong></th>
              <th><strong>&euro;</strong></th>
            </tr>
          </thead>
          <tbody>
            @for (discount of product.discounts; track discount) {
              <tr>
                <td class="discountName">{{ discount.discountName }}</td>
                <td class="discountPercentage">{{ discount.formattedPercentageValue }}</td>
                <td class="discountvalue">{{ discount.formattedValue }}</td>
              </tr>
            }
          </tbody>
        </table>
        <div class="discount-footer"> {{ 'productDetails.discountMessage' | cxTranslate }} </div>
      </div>
    </div>
  }
  <div class="distribution-agreement">
    @if (product.mvgr2 && product.mvgr2.icon && (product.mvgr2.icon.altText || product.mvgr2.name)) {
      <img
        src="{{ mediaService.resolveAbsoluteUrl(product.mvgr2.icon.url) }}" title="{{ product.mvgr2.name }}"
        alt="{{ product.mvgr2.icon.altText }}" />
    }
    @if (product.mvgr2?.name) {
      <span class="distribution-agreement__text">{{ product.mvgr2?.name }}</span>
    }
  </div>
  <div class="distribution-agreement">
    @if (product.mvgr3 && product.mvgr3.icon && (product.mvgr3.icon.altText || product.mvgr3.name)) {
      <img
        src="{{ mediaService.resolveAbsoluteUrl(product.mvgr3.icon.url) }}" title="{{ product.mvgr3.name }}"
        alt="{{ product.mvgr3.icon.altText }}" />
    }
    @if (product.mvgr3?.name) {
      <span class="distribution-agreement__text">{{ product.mvgr3?.name }}</span>
    }
  </div>
}
